import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./Topbar.css";
import logo from "../assets/logo.png";
import adminImg from "../assets/admin.jpg";

export default function Topbar() {
  const navigate = useNavigate();

  const toggleSidebar = () => {
    document.querySelector(".sidebar")?.classList.toggle("open");
  };

  const toggleUserMenu = () => {
    document.getElementById("userMenu")?.classList.toggle("show");
  };

  const logout = () => {
    localStorage.removeItem("loggedInAdmin");
    navigate("/login");
  };

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(".admin-profile")) {
        document.getElementById("userMenu")?.classList.remove("show");
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <header className="top-header">
      <div className="header-left">
        <Link to="/dashboard">
          <img src={logo} className="top-logo" alt="NX Optics" />
        </Link>

        <button className="icon-btn" onClick={toggleSidebar}>☰</button>
      </div>

      <div className="header-right">
        <div className="admin-profile" onClick={toggleUserMenu}>
          <img src={adminImg} alt="Admin" />
          <span className="caret">▾</span>

          <div id="userMenu" className="user-menu">
            <Link to="/account">My Profile</Link>
            <button onClick={logout}>Logout</button>
          </div>
        </div>
      </div>
    </header>
  );
}
